export enum SolicitarCambioType{
  SOLICITADO='solicitado',
  APROBADO ='aprobado',
  RECHAZADO='rechazado',
  APERTURA='apertura'
}
